import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { getStateByPath } from "../../../../redux/selectors";
import {
    ADD_STATE,
    REMOVE_STATE,
} from "../../../../redux/actions/generics/IndexedActions";
import { GenericButton } from "../../../../components/buttons/customButtons";
import { genericIndexedActions } from "../../../../redux/actions/generics/GenericIndexedActions";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import {admissionActivityService} from "../../../../jwt/_services/relations/admissionActivityService";
import {GenericContainer} from "../../../../components/containers/GenericContainer";
import {activityProvider} from "../../../../providers/activityProvider";
import GenericSwitch from "../../../../components/genericComponents/genericSwitch";
import {showToastCustom} from "../../../../components/toast/customToast";
import {error, selectOption} from "../../../../components/i18n/i18n";

const ActivitySection = (props) => {
    const path = props.path + "/activities";

    const parentState = useSelector((state) => getStateByPath(state, props.path));
    const componentState = useSelector((state) => getStateByPath(state, path));

    const { domainObject, app, udn } = parentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];
    const { loading } = componentState?.data || false;

    const [activityId, setActivityId] = useState(null);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        };
    }, []);


    useEffect(() => {
        const dataRequest = {
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                admission: { id: domainObject?.id },
            },
        };

        genericIndexedActions.search(path, admissionActivityService, 0, 1000, dataRequest);
    }, []);

    const notImplemented = (data) => {
        console.log(data);
    };

    const onAdd = (_activity) => {
        if (!_activity) {
            return showToastCustom(error, selectOption);
        }

        const dataRequest = {
            fbDataBase: { id: app?.fbDataBase?.id },
            item: {
                admission: { id: domainObject?.id },
                activity: { id: _activity },
                status: true,
                showOrder: (listDomainObjects.length || 0) + 1,
            },
        }

        genericIndexedActions.save(path, admissionActivityService, dataRequest);
    };

    const handleStatusChange = (id, data, status) => genericIndexedActions.update(path, admissionActivityService, id, {
        fbDataBase:  { id : app?.fbDataBase?.id },
        item: { status, id }
    })

    const confirmDelete = (data) => {
        return ConfirmDelete({ path, data : data, fbDataBaseId :  app?.fbDataBase?.id, remove : genericIndexedActions.delete, service: admissionActivityService } );
    };

    const renderContent = (_option, index) => {
        return (
            <div className={'module-menu-item'}>
                <label className="module-menu-item-title">
                    <h3>{_option.name}</h3>
                </label>
                <div className="float-right">
                    <GenericSwitch
                        id={ _option?.id }
                        initialState={ _option?.status }
                        onChange={ handleStatusChange }
                    />
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={'Desvincular'}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => confirmDelete(_option)}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
            {/*GENERIC CONTAINER VINCULAR + ORDENAR*/}
            <GenericContainer
                titlle={'Actividades incluidas'}
                listItems={listDomainObjects}
                renderContent={renderContent}
                loading={loading}

                provider={activityProvider}
                providerFilter={{item: {status: null, isExtraordinary: false, udn: {id: udn?.id}}}}
                option={activityId}
                setOption={setActivityId}
                onAddItem={onAdd}

                onReorderItems={() => notImplemented('ReorderItem')}
            />
        </>
    );
};

const mapStateToProps = (_) => ({});

const mapActionsToProps = {
    ADD_STATE,
    REMOVE_STATE,
};

export default connect(mapStateToProps, mapActionsToProps)(ActivitySection);
